import * as Sentry from "@sentry/react"
import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { updateI18n } from "lib/i18n"
import { AuthEmployeeResponseData, DataResponse } from "schema"

type AuthResponse = DataResponse<AuthEmployeeResponseData>

export const authEmployeeQuery = (enabled = false) => {
  return queryOptions({
    queryKey: ["auth"],
    queryFn: async () => {
      const { data } = await axios.get<AuthResponse>("/auth")

      const authData = data.data

      Sentry.setUser({
        employeeId: authData.id,
        employeeEmail: authData.email,
        organizationId: authData?.organizationId.toString(),
        companyId: authData?.companyId?.toString(),
      })

      updateI18n(authData.locale)

      return authData
    },
    staleTime: 1000 * 60 * 5,
    enabled,
  })
}
